export default {
    waypointNo: '航点编号',
    addAction: '添加动作',
    saveAction: '保存动作',
    waitForCompletion: '等待完成',
    PTZAction: '云台动作',
    PTZTilt: '云台俯仰角度',
    PTZHeading: '云台航向角度',
    PTZModeSwitch: '云台模式切换',
    PTZHeadFollows: '云台机头跟随',
    PTZPositionKeeping: '云台位置保持',
    cameraAction: '相机动作',
    photograph: '拍照',
    startRecording: '开始录像',
    endRecording: '结束录像',
    zoom: '变焦',
    isochronousPhotography: '等时拍照',
    isometricPhotography: '等距拍照',
    endTakingPictures: '结束拍照',
    pagerAction: '喊话器动作',
    pagerStartsPlaying: '喊话器开始播放',
    pagerStopsPlaying: '喊话器停止播放',
    throwerAction: '抛放器动作',
    throwerDisengaged: '抛放器脱开',
    waterPumpAction: '水泵动作',
    waterPumpOn: '水泵打开',
    waterPumpOff: '水泵关闭',
    audioFrequency: '音频',
    lifeDetectionAction: '生命探测动作',
    lifeDetectionBegins: '生命探测开始',
    lifeDetectionEnd: '生命探测结束',
}